import axiosInstance from "@/lib/axios.instance";
import { Subscription } from "@/types/subscription.types";

export const getSubscription = async (): Promise<Subscription> => {
  const response = await axiosInstance.get("/subscriptions/fetch-sub/");
  return response.data;
};

export const addTopUp = async (amount: number): Promise<any> => {
  const response = await axiosInstance.post("/subscriptions/add-topup/", { amount });
  return response.data;
};
